
export class AppSettings {
/*
    public static BASE_URL = 'loca:8082/financeBack-2012/webresources/';
    public static BASE_URLCRM = 'http://192.168.92.199:8082/crm-1/webresources/';
*/
 /* 
 
  //HASSI public static BASE_URL = 'http://192.168.92.200:8082/financeBack-2012/webresources/';
  public static BASE_URL = 'http://192.168.92.200:8082/financeBack-napec2020/webresources/';
    public static BASE_URLCRM = 'http://192.168.92.200:8082/crm-1/webresources/';
      */
    public static CHEQUE = 'Chéque';
    public static ENCAISSEMENT = 'EN';
    public static PAIEMENT = 'PA';
    public static FINANCE_FOLDER = 'finance';
    public static CONTRACT_FOLDER = 'contrat';
    public static PJOINT_CLIENT_FOLDER = 'pjointclient';
    public static DEVISES = [
        { label: 'DINARS', value: 'dzd' },
        { label: 'EURO', value: 'eur' },
        { label: 'DOLLARS', value: 'usd' },
    ];
    public static TYPES_CLIENTS = [
      { label: 'EXPOSANT', value: 'E' },
      { label: 'EXPOSANT SPONSOR', value: 'ES' },
      { label: 'DELEGUE', value: 'D' },
      { label: 'SPONSOR', value: 'S' },
  ];
    public static ID_SALON = 56;
    public static  DECAL_EXPO = 4000;
    public static  DECAL_STAND = 4000;





    public static BANQUES = [
        "Banque nationale d'Algérie (BNA)",
        "Banque extérieure d'Algérie (BEA)",
        "Banque de l'agriculture et du développement rural (BADR)",
        "Banque de développement local (BDL)",
        "Crédit populaire d'Algérie (CPA)",
        "Caisse nationale de mutualité agricole (CNMA)",
        "Algérie Poste (La Poste)",
        "CNEP-Banque",
        "Al Salam Bank Algeria",
        "AGB Algeria Gulf Bank",
        "Arab Bank PLC Algeria",
        "Arab Banking Corporation (ABC)  Algérie",
        "Banque Al Baraka (Finance islamique) Algérie",
        "BNP Paribas El Djazaïr",
        "Calyon Algérie",
        "Citibank N.A Algéria",
        "Fransabank Al-Djazaïr",
        "Gulf Bank Algérie",
        "HSBC Algérie",
        "Natixis Banque Algérie",
        "Société générale Algérie",
        "Trust Bank Algeria",
        "The Housing Bank For Trade And Finance HBTF Algeria"]



}
